module.exports = __webpack_public_path__ + "img/default5.b3ce5ad2.jpg";